/* BOGO gift picker visibility - shows picker only with a qualifying bag and no gift yet */
(function () {
  var path = window.location.pathname.replace(/\/$/, '');
  if (path !== '/cart') return;
  var BOGO_IDS = null;
  var GIFT_IDS = null;
  function getIds(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { return (data.products || []).map(function (p) { return p.id; }); });
  }
  function getQualifyingData() {
    if (BOGO_IDS && GIFT_IDS) return Promise.resolve({ bogo: BOGO_IDS, gifts: GIFT_IDS });
    return Promise.all([
      getIds('/collections/buy-1-get-1-free/products.json?limit=250'),
      getIds('/collections/free-gift/products.json?limit=250')
    ]).then(function (results) {
      BOGO_IDS = results[0]; GIFT_IDS = results[1];
      return { bogo: BOGO_IDS, gifts: GIFT_IDS };
    });
  }
  function findPickerSection() {
    var headings = document.querySelectorAll('h2');
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].textContent.trim() === 'Pick your free gift') {
        return headings[i].closest('.shopify-section') || headings[i].parentElement;
      }
    }
    return null;
  }
  function updatePickerVisibility() {
    var picker = findPickerSection();
    if (!picker) return;
    Promise.all([
      getQualifyingData(),
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    ]).then(function (results) {
      var ids = results[0]; var cart = results[1];
      var items = (cart && cart.items) || [];
      var hasQualifyingBag = items.some(function (item) { return ids.bogo.indexOf(item.product_id) !== -1; });
      var hasGift = items.some(function (item) { return ids.gifts.indexOf(item.product_id) !== -1; });
      var shouldShow = hasQualifyingBag && !hasGift;
      var isHidden = picker.style.display === 'none';
      if (shouldShow === isHidden) { picker.style.display = shouldShow ? '' : 'none'; }
    }).catch(function () {});
  }
  function init() {
    updatePickerVisibility();
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(updatePickerVisibility, 700);
    });
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
